export enum Browser {

  CHROME = 'CHROME',
  FIREFOX = 'FIREFOX',
  EDGE = 'EDGE',
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  SAFARI = 'SAFARI',
}
